export class TtzkPortalValidationUtil {
  static isNotEmpty(value: string): boolean {
    return value.length > 0;
  }

  static isShorterThan(value: string, maxLength: number): boolean {
    if (value.length === 0) {
      return true;
    }
    return value.length <= maxLength;
  }

  static isNotEmptyShorterThan(value: string, maxLength: number): boolean {
    return (
      TtzkPortalValidationUtil.isNotEmpty(value) &&
      TtzkPortalValidationUtil.isShorterThan(value, maxLength)
    );
  }

  static isNumber(value: string, min?: number, max?: number): boolean {
    if (value.length === 0) {
      return true;
    }
    const numberValue = Number(value);
    if (isNaN(numberValue)) {
      return false;
    }
    if ((min || min === 0) && numberValue < min) {
      return false;
    }
    if ((max || max === 0) && numberValue > max) {
      return false;
    }
    return true;
  }
}
